import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import ListPageHeader from '@shared/ListPageHeader';
import Can from '@shared/permissions/Can';
import ProductLabelTemplatesList from '@shared/product_label_templates/ProductLabelTemplatesList';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { productLabelTemplateService } from '@services/admin/productLabelTemplateService';

const AdminProductLabelTemplatesList: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['products', 'products.label_templates']}
        actions={
          <Can requiredPermission="products:write">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => navigate('/product_label_templates/new')}
            >
              {t('common.button.new')}
            </Button>
          </Can>
        }
      />
      <ProductLabelTemplatesList
        service={productLabelTemplateService}
        role="admin"
      />
    </div>
  );
};

export default AdminProductLabelTemplatesList;
